/* ------------------------------------------------------------------
   HashtagSettingsPage.js — Settings › Hashtags (Part E, T31)
   The LinkedIn / Facebook trimming setting and the saved hashtag sets,
   the same manager the Post composer opens from '# Hashtags'.
------------------------------------------------------------------ */
import React, { useEffect, useState } from 'react'
import axios from 'axios'

import { HashtagSetList } from '../post/components/HashtagSetManager'

const ax = axios.create({ withCredentials: true })

const sectionCard = {
  background  : '#ffffff',
  border      : '1px solid #e5e7eb',
  borderRadius: 12,
  padding     : '22px 24px',
  marginBottom: 20,
  boxShadow   : '0 1px 3px rgba(0,0,0,0.05)',
}

export default function HashtagSettingsPage () {
  const [sets,      setSets]      = useState([])
  const [available, setAvailable] = useState(true)
  const [settings,  setSettings]  = useState(null)
  const [loading,   setLoading]   = useState(true)
  const [error,     setError]     = useState('')

  useEffect(() => {
    let live = true
    Promise.all([ax.get('/api/hashtags/sets'), ax.get('/api/hashtags/settings')])
      .then(([s, t]) => {
        if (!live) return
        setSets(Array.isArray(s.data.sets) ? s.data.sets : [])
        setAvailable(s.data.available !== false)
        setSettings(t.data)
      })
      .catch(() => live && setError('Your hashtag settings could not be loaded. Try again in a moment.'))
      .finally(() => live && setLoading(false))
    return () => { live = false }
  }, [])

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 24, fontWeight: 800, color: '#111827', marginBottom: 4 }}>Hashtags</h2>
        <p style={{ fontSize: 14, color: '#6b7280', margin: 0 }}>Your saved hashtag sets, and how many hashtags go to LinkedIn and Facebook.</p>
      </div>
      <div style={sectionCard}>
        {loading
          ? <div style={{ fontSize: 14, color: '#6b7280' }}>Loading…</div>
          : error
            ? <div style={{ fontSize: 14, color: '#dc2626' }} role='alert'>{error}</div>
            : <HashtagSetList sets={sets} setSets={setSets} available={available} settings={settings} onSettingsChange={setSettings} />}
      </div>
    </div>
  )
}
